module.exports = __webpack_public_path__ + "static/15-96b19867acdf491d558ab2ed8c9e96cc.jpg";